<div class="layout-col full">
  <mat-toolbar elderTheme>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

    <elder-header [header]="'positions.detail' | translate" [subheader]="'ID: ' + item.id">
    </elder-header>
  </mat-toolbar>

  <app-work-item-content class="flex" [item]="item" (close)="close()"> </app-work-item-content>
</div>
